import { put, takeEvery } from 'redux-saga/effects';

import { actions, actionTypes } from '../actions/actions';

function* getAppointments({
  payload: { practiceId, time, dayNum, doctorName, details, token },
}) {
  yield put(
    actions.fetchDoctorAppointments(
      time,
      practiceId,
      dayNum,
      doctorName,
      details,
      token,
    ),
  );
}

function* dayChangedSaga() {
  yield takeEvery(actionTypes.selectDay, getAppointments);
}

export { dayChangedSaga };
